import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M6 8h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AirVent";
const AirVent = memo(themed(Icon));
export {
  AirVent
};
//# sourceMappingURL=air-vent.js.map
